
const propLable = {
    "MADAVE": "Madave",
    "MemoNotWynnQtyWithoutPermExtendedHoldSold": "Memo Not Wynn Qty Without Perm Extended HoldSold",
    "MemoWynnQtyWithoutPermExtendedHoldSold": "Memo Wynn Qty Without Perm Extended Hold Sold",
    "MemoWynnQtyWithoutPermExtendedProgramHoldSold": "Memo Wynn Qty Without Perm Extended Program Hold Sold",
    "MemoNotWynnQtyWithoutPermExtendedProgramHoldSold": "Memo Not Wynn Qty Without Perm Extended Program Hold Sold",
    "OfficeQTYWithoutPermExtendedHoldSold": "Office QTY Without Perm Extended Hold Sold",
    "OnOrder": "On Order",
    "QtyWithHoldSold": "Qty With Hold Sold",
    "QtyWithoutPerm": "Qty Without Perm",
    "QtyWithoutPermExtended": "Qty Without Perm Extended",
    "QtyWithoutPermExtendedHoldSold": "Qty Without Perm Extended Hold Sold",
    "QtyWithoutPermExtendedHoldSoldOnOrder": "Qty Without Perm Extended Hold Sold On Order",
    "QtyWithoutPermExtendedProgram": "Qty Without Perm Extended Program",
    "QtyWithoutPermExtendedProgramHoldSold": "Qty Without Perm Extended Program Hold Sold",
    "QtyWithoutPermExtendedProgramHoldSoldOnOrder": "Qty Without Perm Extended Program Hold Sold On Order",
    "QtyWithoutPermProgram": "Qty Without Perm Program",
    "QtyWithoutProgram": "Qty Without Program",
    "SerialsInStock": "Serials In Stock",
    "MemoShort": "Memo Short",
    "MemoCall": "Memo Call",
    "MemoExtended": "Memo Extended",
    "MemoLong": "Memo Long",
    "MemoPerm": "Memo Perm",
    "MemoProgram": "Memo Program",
    "MemoTiara": "Memo Tiara",
    "MemoTrunk": "Memo Trunk",
    "MemoWedding": "Memo Wedding"
}

export const handleLableToItem = (arr = []) => {
    if (arr.length === 0) {
      return arr;
    }
  
    return arr.map((item) => {
      const transformedItem = {};
  
      Object.keys(item).forEach((key) => {
        transformedItem[key] = {
          label: propLable[key] || key,
          value: item[key],
        };
      });
  
      return transformedItem;
    });
  };